import 'translation/polyglot_polyfill';

// Nothing to do, just want the translation lib
